import { render } from "./Bulk_Upload.vue?vue&type=template&id=216f207f&scoped=true"
import script from "./Bulk_Upload.vue?vue&type=script&lang=js"
export * from "./Bulk_Upload.vue?vue&type=script&lang=js"

import "./Bulk_Upload.vue?vue&type=style&index=0&id=216f207f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216f207f"]])

export default __exports__